import { AfterContentInit, Component, ContentChildren, EventEmitter, Input, Output, QueryList } from '@angular/core';
import { StepComponent } from './step.component';

@Component({
    selector: 'bws-stepper',
    template: `

<!--begin::Stepper-->
<div class="stepper stepper-pills"
  [ngClass]="{'stepper-column d-flex flex-column flex-lg-row': vertical}">

  <!--begin::Nav-->
  <div class="stepper-nav flex-center flex-wrap" [class.flex-center]="!vertical">

    @for (step of steps; track step; let i = $index; let last = $last) {
      <div class="stepper-item mx-8"
        [ngClass]="{'current': step?.isActive, 'completed': isCompleted, 'my-4': !vertical}">
        <!--
        'is-enabled': !step?.isDisabled, 'is-disabled': step?.isDisabled, 'is-completed': isCompleted
        -->
        <!--begin::Wrapper-->
        <div class="stepper-wrapper d-flex align-items-center">
          <!--begin::Icon-->
          <div class="stepper-icon w-40px h-40px" [ngClass]="{'bg-light': !step?.isActive, }">
            <i class="stepper-check fas fa-check"></i>
            <span class="stepper-number">{{i+1}}</span>
          </div>
          <!--end::Icon-->
          <!--begin::Label-->
          <div class="stepper-label">
            <h3 class="stepper-title">
              {{step?.title}}
            </h3>
            <div class="stepper-desc">
              {{step?.subtitle}}
            </div>
          </div>
          <!--end::Label-->
        </div>
        <!--end::Wrapper-->
        <!--begin::Line-->
        @if (!last) {
          <div class="stepper-line h-40px"></div>
        }
        <!--end::Line-->
      </div>
    }

  </div>
  <!--end::Nav-->

  <div class="flex-fill">

    @if (!vertical) {
      <div class="separator my-5"></div>
    }

    <ng-content></ng-content>

    <!-- Footer -->
    <div class="d-flex flex-stack">

      <!--begin::Wrapper-->
      <div class="me-2">
        @if (hasPrevStep && activeStep?.showPrev) {
          <button type="button" class="btn btn-light btn-active-light-primary" (click)="previous()"
            >
            <bws-mdi name="arrow-left"/> {{prevBtnName || 'Previous'}}
          </button>
        }
      </div>
      <!--end::Wrapper-->

      <!--begin::Wrapper-->
      <div>
        @if (hasNextStep && activeStep?.showNext) {
          <button type="button" class="btn btn-primary" (click)="next()"
            [disabled]="!activeStep?.isValid">
            {{nextBtnName || 'Next'}} <bws-mdi name="arrow-right"/>
          </button>
        }
        @if (!hasNextStep) {
          <button type="button" class="btn btn-primary" (click)="complete()"
            [disabled]="!activeStep?.isValid" [bwsShowSpinner]="doneBtnLoading">
            @if (doneBtnIcon) {
              <bws-mdi [name]="doneBtnIcon"/>
              } {{doneBtnName || 'Done'}}
            </button>
          }
        </div>
        <!--end::Wrapper-->
      </div>


    </div>

  </div>
`,
    styles: [],
    standalone: false
})
export class StepperComponent implements AfterContentInit {

  @ContentChildren(StepComponent)
  wizardSteps: QueryList<StepComponent> | undefined;

  private _steps: Array<StepComponent> = [];
  private _isCompleted = false;

  @Input() prevBtnName: string | undefined;
  @Input() nextBtnName: string | undefined;
  @Input() doneBtnName: string | undefined;
  @Input() doneBtnIcon: string | undefined;
  @Input() doneBtnLoading: boolean = false;
  @Input() vertical: boolean = false;
  @Input()  currentStepIndex!: number;

  @Output() currentStepIndexChange = new EventEmitter<number>();
  @Output() onStepChanged: EventEmitter<StepComponent> = new EventEmitter<StepComponent>();

  ngAfterContentInit() {
    this.wizardSteps!.forEach(step => this._steps.push(step));
    if (this.steps?.length) {
      if (this.currentStepIndex > 0 && this.steps.length > this.currentStepIndex) {
        this.steps[this.currentStepIndex].isActive = true;
      } else {
        this.steps[0].isActive = true;
      }
    }
  }

  get steps(): Array<StepComponent> {
    return this._steps.filter(step => !step.hidden);
  }

  get isCompleted(): boolean {
    return this._isCompleted;
  }

  get activeStep(): StepComponent {
    return <StepComponent>this.steps.find(step => step.isActive);
  }

  set activeStep(step: StepComponent) {
    if (step !== this.activeStep && !step.isDisabled) {
      this.activeStep.isActive = false;
      step.isActive = true;
      this.onStepChanged.emit(step);
    }
  }

  public get activeStepIndex(): number {
    return this.steps.indexOf(this.activeStep);
  }

  get hasNextStep(): boolean {
    return this.activeStepIndex < this.steps.length - 1;
  }

  get hasPrevStep(): boolean {
    return this.activeStepIndex > 0;
  }

  public goToStep(step: StepComponent): void {
    if (!this.isCompleted) {
      this.activeStep = step;
    }
  }

  public next(): void {
    if (this.hasNextStep) {
      const nextStep: StepComponent = this.steps[this.activeStepIndex + 1];
      this.activeStep.onNext.emit();
      nextStep.isDisabled = false;
      this.activeStep = nextStep;
    }
  }

  public previous(): void {
    if (this.hasPrevStep) {
      const prevStep: StepComponent = this.steps[this.activeStepIndex - 1];
      this.activeStep.onPrev.emit();
      prevStep.isDisabled = false;
      this.activeStep = prevStep;
    }
  }

  public complete(): void {
    this.activeStep.onComplete.emit();
    // this._isCompleted = true;
  }


}
